import DashboardView from "../../views/dashboard/DashboardView";

export default function DashboardPage() {
  return <DashboardView />;
}
